import Vue from "vue";
import {vm} from "@/main";
import router from "@/router";

const getDefaultState = () => {
    return {
        user: null,
        account: 0,
        currentPlan: {
            next_bill: {
                next_charge_amount: null,
            },
            fastspring: {
                nextChargeDate: null,
            },
            plan_quota: {
                used_storage: null,
                max_storage: null,
            },
            users: {
                added: null,
            }
        },
    };
};

const User = {
    namespaced: true,

    state: getDefaultState(),

    mutations: {
        SET_USER: async (state, user) => {
            state.user = user;
        },

        SET_ACTIVE_ACCOUNT: (state, id) => {
            if (!id) {
                if (localStorage.getItem("activeAccount")) {
                    id = parseInt(localStorage.getItem("activeAccount"));
                    let account_ids = state.user.accounts.map(account => account.id);
                    let account = state.user.accounts.find(account => account.id == id);

                    if (!account_ids.includes(id) || account.suspended_at) {
                        id = state.user.accounts.find(account => !account.suspended_at).id;
                    }
                } else {
                    let accountOwnerAccount = state.user.accounts.find(account => account.role_id == 2);
                    if (accountOwnerAccount) {
                        id = accountOwnerAccount.id;
                    } else {
                        id = state.user.accounts.find(account => (account.organization && !account.suspended_at)).id;
                    }
                }
            }

            localStorage.setItem("activeAccount", id);
            state.account = state.user.accounts.find(account => account.id == id);
        },

        RESET_STATE: state => {
            Object.assign(state, getDefaultState());
        },

        SET_CURRENT_PLAN: (state, payload) => {
            state.currentPlan = payload;
        },

        SET_TERMS_OF_SALE_AGREEMENT: (state, payload) => {
            Vue.set(state.user, 'terms_of_sale_agreement', payload)
        }
    },

    actions: {
        resetState: ({commit}) => {
            commit("RESET_STATE");
        },

        fetchUser: ({commit, dispatch}) => {
            return new Promise((resolve, reject) => {
                Vue.prototype.$apiService
                    .get("user")
                    .then(response => {
                        commit("SET_USER", response.data);
                        commit("SET_ACTIVE_ACCOUNT");
                        resolve(response.data);
                    })
                    .catch(err => {
                        dispatch("resetAll", null, {root: true});
                        router.push({ name: "login" });
                        window.vm.$snackbar("You have been automatically logged out because your session has expired. Please log back in.", "error");
                        reject(err.response);
                    });
            });
        },

        updateProfile: async ({commit, state, dispatch}, payload) => {
            return await Vue.prototype.$apiService
                .patch(`users/${state.user.id}`, payload)
                .then(response => {
                    dispatch("fetchUser");
                })
        },

        switchAccount: async ({ commit, rootState, state }, id) => {
            // commit("SET_ACTIVE_ACCOUNT", id);

            if (window.lutify) {
                await window.lutify.storeLastState();
                await window.lutify.pushLastStates();
            }

            if (!rootState.Plans.selectablePlans.map(plan => plan.id).includes(state.account.plan_id)) {
                window.location.replace(`${window.FYLM_APP_URL}?token=${response.data.access_token}`)
                return;
            }

            localStorage.setItem("activeAccount", id);
            vm.$router.go();
        },

        fetchCurrentPlan: ({commit, state, getters}) => {
            if (getters.isAdminOrLower) return;

            return Vue.prototype.$apiService.get(`accounts/${state.account.id}/current-plan`).then(response => {
                commit("SET_CURRENT_PLAN", response.data);
                return response;
            });
        },

        updateTermsOfSaleAgreement: ({ commit, state }, payload) => {
            // commit('SET_TERMS_OF_SALE_AGREEMENT', payload);
            return Vue.prototype.$apiService
                .patch(`users/${state.user.id}/terms-of-sale-agreement`, {
                    value: payload
                });
        },
    },

    getters: {
        activeAccounts: state => {
            return state.user.accounts.filter(account => account.accepted);
        },

        user: state => {
            return state.user;
        },

        isCurrentPlanFree: (state, getters, rootState) => {
            return (state.currentPlan.id == 1 || state.account.plan_id == rootState.Plans.PLAN_LITE_FREE.id);
        },

        isCurrentPlanLowerThanTeam: state => {
            if (state.currentPlan && state.currentPlan.id < 4) return true;
        },

        isLoggedIn: state => {
            if (state.user) return true;
            else return false;
        },

        isOwnerOfProject: state => project => {
            if (!state.user || !project.owner) return false;

            if (project.owner.id == state.user.id) return true;
            else return false;
        },

        isGuest: state => {
            if (state.account.role_id == 7) return true;
            else return false;
        },

        isMemberOrLower: state => {
            if (state.account.role_id >= 6) return true;
            else return false;
        },

        isAdminOrLower: state => {
            if (state.account.role_id >= 3) return true;
            else return false;
        }
    },
};

export default User;
